import { nativeEvent } from '@/utils/native-event';

type DownloadFileArgs = {
  fileName: string;
  url: string;
};

export const downloadUtil = ({ url, fileName }: DownloadFileArgs) => {
  fetch(url)
    .then((bytes) => bytes.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `${fileName}`;

      let el: HTMLElement;

      if (document.activeElement === window.document.body) {
        el = window.document.body;
      } else {
        if (document.activeElement?.parentElement) {
          el = document.activeElement.parentElement;
        } else {
          el = window.document.body;
        }
      }
      el.appendChild(a);

      const preventPropagation = (e: Event) => {
        e.stopPropagation();
        a.removeEventListener('click', preventPropagation);
      };
      a.addEventListener('click', preventPropagation);

      a.click();

      el.removeChild(a);
      window.URL.revokeObjectURL(url);
    });
};

export const sendDownloadDataToReactNative = (data: DownloadFileArgs) => {
  nativeEvent(['download-data', JSON.stringify(data)]);
};
